import React from "react";

const SignUpForm = () => {
  return <div>SignUpForm</div>;
};

export default SignUpForm;
